<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          IMPRESSÃO DE FATURA ROYALTIES INDIVIDUAL
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="search"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="500">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap"></th>
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12" width="250px">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Faturamento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Qt. Total
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Fatura
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Royalties
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="royalty in royalties" :key="royalty.id">
                              <td>
                                <v-icon @click="print(royalty)"
                                  >mdi-printer</v-icon
                                >
                              </td>
                              <td>
                                {{ royalty.company.code }}
                              </td>
                              <td>
                                {{ royalty.company.name }}
                              </td>
                              <td>
                                {{ royalty.company.code }}-{{ royalty.code }}
                              </td>
                              <td>
                                {{ royalty.created_at | dateTimeToDateBr }}
                              </td>
                              <td class="text-right">
                                {{
                                  getTotalInvoices(royalty) | currencyEuaToBr
                                }}
                              </td>
                              <td class="text-right">
                                {{ getTotalItemsInvoices(royalty) }}
                              </td>
                              <td class="text-right">
                                {{
                                  getTotalInvoices(royalty) | currencyEuaToBr
                                }}
                              </td>
                              <td class="text-right">
                                {{ royalty.value | currencyEuaToBr }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    showAlert: false,
    messageAlert: false,
    typeAlert: "error",
    lazy: false,
    valid: true,
    royalties: [],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
  }),
  computed: {},
  filters: {
    currencyEuaToBr: function (value) {
      if (!value) return "0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    dateToBr: function (date) {
      if (date == undefined) return "";
      return date.split("-").reverse().join("/");
    },
    dateTimeToDateBr: function (datetime) {
      if (datetime == undefined) return "";
      let [date] = datetime.split(" ");
      return date.split("-").reverse().join("/");
    },
  },
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {},
    validate() {},
    async search() {
      this.loading = true;
      this.showAlert = false;
      this.royalties = [];
      const data = {
        month: this.month,
        year: this.year,
      };
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}royalty/search`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        console.log(response);
        if (response.length === 0) {
          this.typeAlert = "warning";
          this.messageAlert =
            "Não foi encontrado faturas para o periodo selecionado";
          this.showAlert = true;
        } else {
          this.royalties = response;
          console.log("else");
        }
      } catch (error) {
        console.log(error.message);
        this.typeAlert = "error";
        this.messageAlert =
          "Houve um problema ao buscar as faturas, tente novamente mais tarde";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    getTotalInvoices(royalty) {
      return royalty.invoices
        .map((item) => parseFloat(item.invoice.value))
        .reduce((prev, curr) => prev + curr, 0);
    },
    getTotalItemsInvoices(royalty) {
      return royalty.invoices
        .map((item) => parseInt(item.invoice.quantity))
        .reduce((prev, curr) => prev + curr, 0);
    },
    async print(royalty) {
      this.showAlert = false;
      this.loading = true;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      try {
        let data = royalty;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}royalty/print`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        this.loading = false;
        let res = await response.json();
        console.log(res);
        this.download.name = res.nome;
        this.download.link = `${URL}royalty/download/${res.nome}`;
        this.linkDownload = true;
      } catch (error) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível imprimir esse relatório, entre em contato com o suporte";
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
